import React, { useEffect, useState } from 'react';
import useGlobal from '../../../store';
import Container from '../../components/container';
import { formatRub, formatRuDate, manualPaymentText } from '../../../store/actions/tariff';
import './tariff.scss';

const PAYMENT_OFF = 'Онлайн-оплата ещё не включена. Напишите в поддержку';

const MyTariff = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { user_id, user_role } = globalState;
  const role = Number(user_role);
  const seesMoney = role === 1 || role === 2;

  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState('');
  const [ tariff, setTariff ] = useState(null);
  const [ catalog, setCatalog ] = useState([]);
  const [ payments, setPayments ] = useState([]);
  const [ notice, setNotice ] = useState('');

  useEffect(() => {

    if (!user_id) return;

    let cancelled = false;

    async function load() {

      setLoading(true);
      setError('');

      const ownResult = await globalActions.tariff.own();
      if (cancelled) return;

      if (!ownResult.success) {
        setLoading(false);
        setError(ownResult.text || 'Не удалось загрузить тариф');
        return;
      }

      setTariff(ownResult.data.tariff);
      setCatalog(Array.isArray(ownResult.data.catalog) ? ownResult.data.catalog : []);

      if (seesMoney) {

        const history = await globalActions.tariff.payments();
        if (cancelled) return;
        setPayments(history.success ? history.payments : []);
        if (!history.success && !history.tariffRequired) {
          setError(history.text || '');
        }

      }

      setLoading(false);

    }

    load();

    return () => { cancelled = true; };

  }, [ user_id, seesMoney ]);

  function statusText() {

    if (!tariff || tariff.state === 'none' || !tariff.name) return 'Тариф не подключён';
    const date = formatRuDate(tariff.endsAt);
    if (tariff.state === 'expired') return `${tariff.name}, закончился ${date}`;
    if (tariff.state === 'active') return `${tariff.name} до ${date}`;
    return 'Тариф не подключён';

  }

  return (

    <Container>

      <div className = "my-tariff">

        <h1>Мой тариф</h1>

        { !user_id || loading ? <p className = "my-tariff__status">Загрузка...</p> : null }

        { error ? <p className = "my-tariff__error">{ error }</p> : null }

        { user_id && !loading && tariff ? (

          <div>

            <p className = "my-tariff__status">{ statusText() }</p>

            { seesMoney && (tariff.state === 'active' || tariff.state === 'expired') && tariff.priceRub !== null && tariff.priceRub !== undefined ? (

              <p className = "my-tariff__status">Цена: { formatRub(tariff.priceRub) } ₽</p>

            ) : null }

            { !seesMoney ? <p className = "my-tariff__note">Тариф компании</p> : null }

            { seesMoney ? (

              <div>

                <h2>История</h2>

                { payments.length === 0 ? <p className = "my-tariff__note">Записей пока нет</p> : (

                  <ul className = "my-tariff__list">

                    { payments.map((row, index) => (

                      <li className = "my-tariff__row" key = { `${row.createdOn}-${index}` }>

                        <span>{ formatRuDate(row.createdOn) }</span>
                        <span>{ row.tariffName }</span>
                        <span>{ manualPaymentText(row) }</span>

                      </li>

                    ))}

                  </ul>

                )}

                {/* <h2>Другие тарифы</h2>

                <ul className = "my-tariff__list">

                  { catalog.map((item) => (

                    <li className = "my-tariff__row" key = { item.code }>

                      <span>{ item.name }</span>
                      <span>{ item.durationDays } дн.</span>
                      <span>{ formatRub(item.priceRub) } ₽</span>

                      { tariff && tariff.state === 'active' && item.code === tariff.code ? (

                        <span className = "my-tariff__active">Активен</span>

                      ) : (

                        <button type = "button" onClick = { () => setNotice(PAYMENT_OFF) }>Перейти</button>

                      )}

                    </li>

                  ))}

                </ul> */}

                { notice ? <p className = "my-tariff__note">{ notice }</p> : null }

              </div>

            ) : null }

          </div>

        ) : null }

      </div>

    </Container>

  );

};

export default MyTariff;
